import React, { useState } from "react";
import { Row, Col, Accordion, Card, Carousel } from "react-bootstrap";
import darkSeparatorBottom from "../../../../img/dark-separator-bottom.png";
import slideshowOne from "../../../../img/slideshow-1.png";
import slideshowTwo from "../../../../img/slideshow-2.png";
import slideshowThree from "../../../../img/slideshow-3.png";
import slideshowFour from "../../../../img/slideshow-4.png";

import "./style.scss";

const Index = () => {
  const [showIndex, setShowIndex] = useState("0");

  return (
    <div>
      <section className="frontpage-features-list-section">
        <div className="inner-frontpage-features-list-container">
          <div className="content-container">
            <Row className="features-row">
              <Col
                xs={{ span: 12, order: 2 }}
                sm={{ span: 12, order: 2 }}
                lg={{ span: 6, order: 1 }}
                className="explanation-col"
              >
                <Col>
                  <h3 className="section-title">
                    Se hvordan Leadfind kan gjøre din bedrift mer lønnsom.
                  </h3>
                  <p className="section-description">
                    Dette er en sniktitt på noe av det du og virksomheten din
                    får tilgang til med et standard abonnement.
                  </p>
                  <Accordion
                    className="features-accordion"
                    defaultActiveKey={showIndex}
                  >
                    <Card
                      className="feature-card"
                      onClick={() => setShowIndex("0")}
                    >
                      <Accordion.Toggle
                        as={Card.Header}
                        className="card-header"
                        eventKey={"0"}
                      >
                        <h4 className="card-title">Listegenerering</h4>
                        <i className="fas fa-chevron-up toggle-indicator"></i>
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey={"0"}>
                        <Card.Body>
                          <p className="card-description">
                            Med Leadfind kan du opprette lister på opp til
                            10.000 foretak med oppdatert informasjon hentet
                            direkte fra offentlige registre.
                          </p>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card
                      className="feature-card"
                      onClick={() => setShowIndex("1")}
                    >
                      <Accordion.Toggle
                        as={Card.Header}
                        className="card-header"
                        eventKey={"1"}
                      >
                        <h4 className="card-title">Bedriftsinformasjon</h4>
                        <i className="fas fa-chevron-up toggle-indicator"></i>
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey={"1"}>
                        <Card.Body>
                          <p className="card-description">
                            For hvert enkelt foretak finner du raskt og enkelt
                            all relevant bedriftsinformasjon og liste over
                            roller i selskapet.
                          </p>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card
                      className="feature-card"
                      onClick={() => setShowIndex("2")}
                    >
                      <Accordion.Toggle
                        as={Card.Header}
                        className="card-header"
                        eventKey={"2"}
                      >
                        <h4 className="card-title">Internt samarbeid</h4>
                        <i className="fas fa-chevron-up toggle-indicator"></i>
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey={"2"}>
                        <Card.Body>
                          <p className="card-description">
                            På hver liste kan man enkelt markere respons og
                            gjøre noteringer på hvert selskap som kollegaer
                            enkelt kan se.
                          </p>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card
                      className="feature-card"
                      onClick={() => setShowIndex("3")}
                    >
                      <Accordion.Toggle
                        as={Card.Header}
                        className="card-header"
                        eventKey={"3"}
                      >
                        <h4 className="card-title">Bygg pipelines</h4>
                        <i className="fas fa-chevron-up toggle-indicator"></i>
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey={"3"}>
                        <Card.Body>
                          <p className="card-description">
                            For å segmentere ulike salgstunneler kan du opprette
                            så mange pipelines du ønsker, med stegene du selv
                            kan navngi.
                          </p>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </Col>
              </Col>
              <Col
                xs={{ span: 12, order: 1 }}
                sm={{ span: 12, order: 1 }}
                md={{ span: 6, order: 1 }}
                lg={{ span: 6, order: 2 }}
                className="illustration-col my-auto"
              >
                <Col>
                  <Carousel
                    fade
                    controls={false}
                    indicators={false}
                    activeIndex={parseInt(showIndex)}
                  >
                    <Carousel.Item>
                      <img
                        className="feature-illustration"
                        alt="Listegenerering"
                        src={slideshowOne}
                      />
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="feature-illustration"
                        alt="Bedriftsinformasjon"
                        src={slideshowTwo}
                      />
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="feature-illustration"
                        alt="Internt samarbeid"
                        src={slideshowThree}
                      />
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="feature-illustration"
                        alt="Bygg pipelines"
                        src={slideshowFour}
                      />
                    </Carousel.Item>
                  </Carousel>
                </Col>
              </Col>
            </Row>
          </div>
        </div>
      </section>
      <img
        alt="Skille"
        className="features-bottom-separator"
        src={darkSeparatorBottom}
      />
    </div>
  );
};

export default Index;
